import { useCallback, useLayoutEffect } from 'react';
import { useObjectRef } from '@react-aria/utils';
import { SCROLL_BUFFER_HEIGHT } from '../../constants.js';

/**
 * Smart Resize Hook
 * Automatically adjusts the height of the container based on textarea scrollHeight.
 * Activated only when `resize === 'smart'`.
 */
var useSmartResize = function useSmartResize(containerRef, ref, resize, value) {
  var container = useObjectRef(containerRef);
  var input = useObjectRef(ref);
  var adjustHeight = useCallback(function () {
    if (resize !== 'smart' || !container.current || !input.current) return;
    container.current.style.height = 'auto'; // Reset first
    container.current.style.height = "".concat(input.current.scrollHeight + SCROLL_BUFFER_HEIGHT, "px");
  }, [container, input, resize]);

  // Adjust on mount and whenever `value` changes
  useLayoutEffect(function () {
    adjustHeight();
  }, [adjustHeight, value]);
  return {
    containerRef: container,
    inputRef: input
  };
};

export { useSmartResize };
//# sourceMappingURL=useSmartResize.js.map
